import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ToastService } from '../toast-service';
@Injectable()
export class ConnectivityInterceptor implements HttpInterceptor {
  private connectivityCheckEndpoints: string[] = [
    environment.webapi.baseUrl
  ].filter(url => !!url);

  constructor(private toastService: ToastService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (
          event instanceof HttpResponse &&
          event.status >= HttpStatusCode.Ok &&
          event.status < HttpStatusCode.MultipleChoices &&
          this.isConnectivityCheckEndpoint(req.url)
        ) {
        }
      })
    );
  }

  private isConnectivityCheckEndpoint(requestUrl: string): boolean {
    return this.connectivityCheckEndpoints.some(baseUrl => requestUrl.startsWith(baseUrl));
  }
}
